import { useMemo } from 'react';
import {
  GetPatientsBalanceResponse,
  GetPatientsBalanceResponse_PatientBalance,
} from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { PaginatedList } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { useBulkCollectionsFilterShallowStore } from '../../../../store/bulk-collections-filter-store';
import { Row } from '../../common/mobile-list/row';
import { searchByText } from '../../utils';

type MobileListProps = {
  isLoading: boolean;
  collections?: GetPatientsBalanceResponse;
  selected: string[];
  toggleSelection: (patientId: string) => void;
};
export const MobileList = ({ isLoading, collections, selected, toggleSelection }: MobileListProps) => {
  const { t } = useTranslation('payments');
  const alert = useAlert();
  const { balanceType, searchValue } = useBulkCollectionsFilterShallowStore('balanceType', 'searchValue');

  const filteredCollections = useMemo(() => {
    let result = collections?.patientBalances ?? [];
    if (searchValue) {
      result = searchByText(result, searchValue);
    }

    if (balanceType.length > 0) {
      result = result.filter((item) => balanceType.includes(item.balanceType));
    }

    return result;
  }, [balanceType, searchValue, collections?.patientBalances]);

  return (
    <PaginatedList
      listData={filteredCollections}
      renderListItem={({ index, listItem }) => (
        <Row
          index={index}
          selected={selected}
          data={listItem}
          onClick={(data: GetPatientsBalanceResponse_PatientBalance) => {
            if (!data.phoneNumber) {
              alert.error(t("Request can't be created because no phone number is on file"));
            } else {
              toggleSelection(data.patientId);
            }
          }}
        />
      )}
      hasNextPage={false}
      isLoading={isLoading}
      endOfListText={`🎉 ${t('You have reached the end')}`}
    />
  );
};
